module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-9-d6d3457b3b659025fd78e63b6cb39081.webp";